// /*! Copyright (c) Safe As Milk. All rights reserved. */
// import Cart from "cart-store";

// class CartLink extends HTMLElement {
//     constructor() {
//         super();
//         this.itemsCount = this.querySelector("items-count");
//     }
//     connectedCallback() {
//         this.unsubscribe = Cart.subscribe((state => {
//             this.itemsCount.innerHTML = state.cart.item_count.toString();
//         }));
//     }
//     disconnectedCallback() {
//         this.unsubscribe();
//     }
// }

// customElements.define("cart-link", CartLink);
// //# sourceMappingURL=cart-link.js.map

/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class CartLink extends HTMLElement {
    constructor() {
        super();
        this.itemsCount = this.querySelector("items-count");
    }
    connectedCallback() {
        this.unsubscribe = Cart.subscribe((state => {
            // Reorder feature
            //   {% comment %} Hide charges {% endcomment %}
            const items = state.cart?.items;
            let finalItemsCount = state.cart.item_count;
            if(items){
               const charges = items.filter((item) => item.handle == "shipping-charges" || item.handle == "tax-charges")
               if(charges.length > 0){
                finalItemsCount = state.cart.item_count - charges.length;
               }
            }
            this.itemsCount.innerHTML =  state.cart.item_count ? finalItemsCount.toString() : "0";
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
    }
}

customElements.define("cart-link", CartLink);
//# sourceMappingURL=cart-link.js.map
